export default __webpack_public_path__ + "static/media/cartagena.41e80235.jpg";